import { DefaultThemeConfiguration } from './default';
import { DarkThemeConfiguration } from './dark';
export const DefaultTheme = Object.assign({}, DefaultThemeConfiguration);
export const DarkTheme = Object.assign({}, DarkThemeConfiguration);
export const Themes = {
    DefaultTheme,
    DarkTheme,
};
